import React from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  isAuthenticated,
  getAppContextThunk,
} from "../features/context/contextSlice";
import { getHubDataThunk } from "../features/hub/hubSlice";
import { updateProbeTemperature } from "../features/probe/probeSlice";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";

import {
  HubConnection,
  HubConnectionBuilder,
  HubConnectionState,
  JsonHubProtocol,
} from "@microsoft/signalr";
import { getAPIURL } from "../api/index";

import Login from "features/context/Login";
import Home from "features/home/Home";
import Probe from "features/probe/Probe";
import ProbeSettings from "features/probe/pages/ProbeSettings";
import StandardLayout from "components/StandardLayout";
import Loading from "components/Loading";
import Logs from "features/logs/Logs";

const App = () => {
  const dispatch = useDispatch();
  const isUserAuthenticated = useSelector(isAuthenticated);
  const [connection, setConnection] = useState(null);

  useEffect(() => {
    const newConnection = new HubConnectionBuilder()
      .withUrl(getAPIURL("NotificationHub"))
      .withAutomaticReconnect()
      .build();

    setConnection(newConnection);
  }, []);

  useEffect(() => {
    if (connection) {
      connection
        .start()
        .then((result) => {
          connection.on("ReceiveNotification", (message) => {
            dispatch(
              updateProbeTemperature({
                deviceID: message.deviceID as string,
                latestTemperature: message.temperature as number,
              })
            );
          });
        })
        .catch((e) => console.log("Connection failed: ", e));
    }
  }, [connection]);

  useEffect(() => {
    if (!isUserAuthenticated) dispatch(getAppContextThunk());
    if (isUserAuthenticated) dispatch(getHubDataThunk());
  });

  const PrivateRoute = ({ children, ...rest }) => {
    return (
      <Route
        {...rest}
        render={({ location }) => {
          if (isUserAuthenticated == true) {
            return children;
          }

          if (isUserAuthenticated === false) {
            return (
              <Redirect
                to={{
                  pathname: "/login",
                  state: { from: location },
                }}
              />
            );
          }

          return <Loading></Loading>;
        }}
      />
    );
  };

  return (
    <Router>
      <Switch>
        {/* Login */}
        <PrivateRoute exact path="/">
          <StandardLayout>
            <Home />
          </StandardLayout>
        </PrivateRoute>
        <Route exact path="/login">
          <Login />
        </Route>

        <PrivateRoute path="/home">
          <StandardLayout>
            <Home />
          </StandardLayout>
        </PrivateRoute>

        <PrivateRoute path="/logs">
          <StandardLayout>
            <Logs />
          </StandardLayout>
        </PrivateRoute>

        <PrivateRoute path="/probe/:id">
          <StandardLayout>
            <Probe />
          </StandardLayout>
        </PrivateRoute>

        <PrivateRoute path="/probeSettings/:id">
          <StandardLayout>
            <ProbeSettings />
          </StandardLayout>
        </PrivateRoute>

        <Route path="*">
          <p>404 :(</p>
        </Route>
      </Switch>
    </Router>
  );
};

export default App;
